import { useListServerTemplates } from '@/services/template'
import { ServerTemplateCard } from './ServerTemplateCard'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ErrorMessage } from '@/components/error-message'
import { LoadingMessage } from '@/components/loading-message'

const DashboardTemplates = () => {
  const { data: templates, isLoading, error } = useListServerTemplates()

  if (isLoading) {
    return <LoadingMessage message="Loading templates..." centered />
  }

  if (error) {
    return (
      <ErrorMessage message={`Error loading templates: ${error.message}`} />
    )
  }

  return (
    <div className="mx-auto space-y-10">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-3xl font-medium">Server Templates</h2>
        <Button disabled>
          <Plus className="w-4 h-4 mr-2" />
          New Template
        </Button>
      </div>

      {templates && templates.length > 0 ? (
        <div className="space-y-4">
          {templates.map((template) => (
            <ServerTemplateCard
              key={template.template_id}
              id={String(template.template_id)}
              name={template.template_name}
              specs={{
                cpu: {
                  count: Number(template.cpu_limit_count),
                  ramGb: Number(template.ram_limit_gb),
                },
                gpu: {
                  count: Number(template.gpu_request_count),
                  memoryGb: Number(template.gpu_request_gmem),
                },
                machineImage: template.machine_image,
                storage: {
                  ephemeralGb: Number(template.ephemeral_storage_limit_gb || 0),
                },
              }}
              price={parseFloat((template.price / 100).toFixed(2))}
              selected={false}
              onSelect={() => {}}
            />
          ))}
        </div>
      ) : (
        <div className="text-center p-10 bg-foreground/10 rounded-lg">
          <p className="text-lg">There are no templates available.</p>
        </div>
      )}
    </div>
  )
}

export default DashboardTemplates
